import { render, staticRenderFns } from "./agro-details-page.vue?vue&type=template&id=fb042c0e&scoped=true"
import script from "./agro-details-page.vue?vue&type=script&lang=js"
export * from "./agro-details-page.vue?vue&type=script&lang=js"
import style0 from "./agro-details-page.vue?vue&type=style&index=0&id=fb042c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb042c0e",
  null
  
)

export default component.exports